import React, { useState } from "react";
import EditProjectModal from "./EditProjectModal";
import Icon22 from "../img/efd2a7af2d5ebcce4b20e5c9794b3ea23005e284d3041cbac31c48228ed046a4.svg";

function ProjectInfo() {
  const [isEditOpen, setIsEditOpen] = useState(false);
  const projectData = JSON.parse(localStorage.getItem('selectedProjectDetails')) || {};

  const formatAddress = () => {
    // Use the individual address components if available
    const street = projectData.street || '';
    const city = projectData.city || '';
    const state = projectData.state || '';
    const zipCode = projectData.zipCode || '';
    
    // If we have individual components, format them
    if (street || city || state || zipCode) {
      const firstLine = street;
      const secondLine = [city, state, zipCode].filter(Boolean).join(', ');
      
      if (firstLine && secondLine) {
        return (
          <div>
            <div className="truncate" title={firstLine}>{firstLine}</div>
            <div className="truncate" title={secondLine}>{secondLine}</div>
          </div>
        );
      } else if (secondLine) {
        return <div className="truncate" title={secondLine}>{secondLine}</div>;
      }
    }
    
    // Fall back to the projectAddress string if individual components aren't available
    if (projectData.projectAddress && projectData.projectAddress !== '-') {
      const parts = projectData.projectAddress.split(', ');

      if (parts.length >= 3) {
        const street = parts[0];
        const cityStateZip = parts.slice(1).join(', ');
        return (
          <div>
            <div className="truncate" title={street}>{street}</div>
            <div className="truncate" title={cityStateZip}>{cityStateZip}</div>
          </div>
        );
      }

      return <div className="truncate" title={projectData.projectAddress}>{projectData.projectAddress}</div>;
    }
    
    return '-';
  };

  const formatDate = (dateString) => {
    if (!dateString || dateString === '-') return '-';

    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });

    const getOrdinalSuffix = (d) => {
      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };

    const ordinalSuffix = getOrdinalSuffix(day);
    return (
      <span>
        {day}<sup className="text-xs">{ordinalSuffix}</sup> {month}
      </span>
    );
  };

  const handleMapClick = () => {
    // Use individual components to build a more accurate map URL if available
    const street = projectData.street || '';
    const city = projectData.city || '';
    const state = projectData.state || '';
    const zipCode = projectData.zipCode || '';
    
    if (city || state) {
      const addressParts = [street, city, state, zipCode].filter(Boolean);
      const formattedAddress = addressParts.join(', ');
      window.open(`https://maps.google.com/?q=${encodeURIComponent(formattedAddress)}`, '_blank');
    } else if (projectData.projectAddress && projectData.projectAddress !== '-') {
      window.open(`https://maps.google.com/?q=${encodeURIComponent(projectData.projectAddress)}`, '_blank');
    }
  };

  return (
    <div className="flex flex-col px-4 py-2 text-gray-600">
      <div className="mb-4">
        <div className="flex items-center justify-between mb-1">
          <div className="text-sm font-medium">Customer:</div>
          <button
            onClick={() => setIsEditOpen(true)}
            className="text-sm text-red-700 hover:underline"
          >
            Edit
          </button>
        </div>
        <div className="text-base text-gray-900 truncate" title={projectData.customerName || '-'}>
          {projectData.customerName || '-'}
        </div>
      </div>

      <div className="mb-4">
        <div className="text-sm font-medium mb-1">Project Address:</div>
        <div className="text-base text-gray-900">
          {formatAddress()}
        </div>
        <button
          onClick={handleMapClick}
          className="w-full mt-2 flex items-center justify-center gap-2 px-4 py-2 text-sm text-white bg-red-700 rounded hover:bg-red-800 transition-colors"
        >
          <img src={Icon22} className="w-4 h-4" alt="Map Icon" />
          <span>Map</span>
        </button>
      </div>

      <div className="space-y-2">
        <div className="flex items-center">
          <div className="w-32 text-sm">Billing Date</div>
          <div className="text-sm text-gray-900">{formatDate(projectData.billingDate)}</div>
        </div>

        <div className="flex items-center">
          <div className="w-32 text-sm">Tax Exempt</div>
          <div className="text-sm text-gray-900">{projectData.taxExempt || '-'}</div>
        </div>

        <div className="flex items-center">
          <div className="w-32 text-sm">Certified Payroll</div>
          <div className="text-sm text-gray-900">{projectData.certifiedPayroll || '-'}</div>
        </div>

        <div className="flex items-center">
          <div className="w-32 text-sm">P&P Bonds</div>
          <div className="text-sm text-gray-900">{projectData.ppBonds || '-'}</div>
        </div>

        <div className="flex items-center">
          <div className="w-32 text-sm">CCIP</div>
          <div className="text-sm text-gray-900">{projectData.ccip || '-'}</div>
        </div>

        <div className="flex items-center">
          <div className="w-32 text-sm">Project Status</div>
          <div className="text-sm text-gray-900" title={projectData.projectStatus || '-'}>
            {projectData.projectStatus || '-'}
          </div>
        </div>
      </div>

      {isEditOpen && (
        <EditProjectModal
          isOpen={isEditOpen}
          onClose={() => setIsEditOpen(false)}
          initialData={projectData}
        />
      )}
    </div>
  );
}

export default ProjectInfo;
